// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"close_button__closeIcon__coy20 position__pos_absolute__CTqRu animations__fade_in_delayed__cD4JG animations__fade_in__ZE4EP"};